/**
 * @generated SignedSource<<f9d8385a85ca006175ae3ede147c04fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRendererStepThru_piece$data = {
  readonly id: string;
  readonly file: {
    readonly notes: ReadonlyArray<{
      readonly bulb_id: string;
      readonly note_duration: number;
      readonly note_start: number;
      readonly midi_number: number;
      readonly " $fragmentSpreads": FragmentRefs<"PieceRendererStepThruNote_note">;
    }>;
  } | null;
  readonly " $fragmentType": "PieceRendererStepThru_piece";
};
export type PieceRendererStepThru_piece$key = {
  readonly " $data"?: PieceRendererStepThru_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererStepThru_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRendererStepThru_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicPieceFileNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bulb_id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "midi_number",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PieceRendererStepThruNote_note"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "1ae1b39bcee4af35b03a7a999d48af68";

export default node;
